import React from 'react';
import Divider from '@material-ui/core/Divider';
import Checkbox from "@material-ui/core/Checkbox";
import AccordionActions from '@material-ui/core/AccordionActions';
import MultipleSelect from '../../components/MultipleSelect/MultipleSelect';
import TDatePicker from '../../components/TDatePicker/TDatePicker';
import { TDatePickerTypes } from '../../components/TDatePicker/TDatePicker';
import { DELIVERY_TYPE_ARR, CONTRACT_TYPE_ARR, TRADING_VENUE_ARR, PRODUCT_ARR, TRADER_ARR,
         POSITION_ARR, POSITION_PERIOD_ARR, PRICE_SOURCES, PRICE_SOURCE_ARR } from '../../utils/constants';
import moment from 'moment';
import { getLocalStorage, setLocalStorage } from '../../../helpers/localStorageHelper';
import TDropdown from '../../components/TDropdown/TDropdown';


const localStorageConfig = {
    book: {
        ownerPage: "positionST",
        ownerElement: "filters",
        key:"selectedBooks",
        matchKey: "id"
    },
    counterParty: {
        ownerPage: "positionST",
        ownerElement: "filters",
        key:"selectedCounterParties",
        matchKey: "id"
    },
    market: {
        ownerPage: "positionST",
        ownerElement: "filters",
        key: "selectedMarkets",
        matchKey: "id"
    },
    position: {
        ownerPage: "positionST",
        ownerElement: "filters",
        key: "selectedPositions",
        matchKey: "id"
    },
    period: {
        ownerPage: "positionST",
        ownerElement: "filters",
        key: "selectedPeriods",
        matchKey: "id"
    },
    company: {
        ownerPage: "positionST",
        ownerElement: "filters",
        key: "selectedCompanies",
        matchKey: "id"
    },
    product: {
        ownerPage: "positionST",
        ownerElement: "filters",
        key:"selectedProducts",
        matchKey: "value"
    },
    tradingVenue: {
        ownerPage: "positionST",
        ownerElement: "filters",
        key: "selectedTradingVenues",
        matchKey: "value"
    },
    trader: {
        ownerPage: "positionST",
        ownerElement: "filters",
        key:"selectedTraders",
        matchKey: "value"
    },
    deliveryType: {
        ownerPage: "positionST",
        ownerElement: "filters",
        key: "selectedDeliveryTypes",
        matchKey: "value"
    },
    contractType: {
        ownerPage: "positionST",
        ownerElement: "filters",
        key: "selectedContractTypes",
        matchKey: "value"
    },
    startDate: {
        ownerPage: "positionST",
        ownerElement: "filters",
        key: "selectedStartDate",
    },
    endDate: {
        ownerPage: "positionST",
        ownerElement: "filters",
        key: "selectedEndDate",
    },
    hidePast: {
        ownerPage: "positionST",
        ownerElement: "filters",
        key: "hidePast",
    },
    adjustment: {
        ownerPage: "positionST",
        ownerElement: "filters",
        key: "includeAdjustment",
    },
    priceSource: {
        ownerPage: "positionST",
        ownerElement: "filters",
        key: "selectedPriceSource",
    },
}

class PosAndMarkFilter extends React.Component {
    state = {
        selectedPositions: this.getOrElseLocalStorageAsList(localStorageConfig.position, POSITION_ARR),
        selectedPeriods:  this.getOrElseLocalStorageAsList(localStorageConfig.period, POSITION_PERIOD_ARR),
        selectedMarkets: this.getOrElseLocalStorageAsList(localStorageConfig.market, this.props.marketNames),
        selectedCompanies: this.getOrElseLocalStorageAsList(localStorageConfig.company, this.props.counterPartyNames.filter(c => c.type === "Vitus")),
        selectedCounterParties: this.getOrElseLocalStorageAsList(localStorageConfig.counterParty, this.props.counterPartyNames.filter(c => c.type !== "Vitus")),
        selectedProducts: this.getOrElseLocalStorageAsList(localStorageConfig.product, PRODUCT_ARR),
        selectedTradingVenues: this.getOrElseLocalStorageAsList(localStorageConfig.tradingVenue, TRADING_VENUE_ARR),
        selectedTraders: this.getOrElseLocalStorageAsList(localStorageConfig.trader, TRADER_ARR),
        selectedDeliveryTypes: this.getOrElseLocalStorageAsList(localStorageConfig.deliveryType, DELIVERY_TYPE_ARR),
        selectedContractTypes: this.getOrElseLocalStorageAsList(localStorageConfig.contractType, CONTRACT_TYPE_ARR),
        selectedBooks: this.getOrElseLocalStorageAsList(localStorageConfig.book, this.props.bookNames.filter(b => b.value === "EU" )),
        selectedStartDate: new Date(this.getOrElseLocalStorage(localStorageConfig.startDate, new Date(new Date().getFullYear(),new Date().getMonth(), 1))),
        selectedEndDate: new Date(this.getOrElseLocalStorage(localStorageConfig.endDate, new Date(new Date().getFullYear() , new Date().getMonth() + 2, 1))),
        selectedPriceSource: this.getOrElseLocalStorage(localStorageConfig.priceSource, PRICE_SOURCES.vitus),
        hidePast: this.getOrElseLocalStorage(localStorageConfig.hidePast, true),
        includeAdjustment: this.getOrElseLocalStorage(localStorageConfig.adjustment, true),
        bookNames: this.props.bookNames,
        counterPartyNames: this.props.counterPartyNames,
        marketNames: this.props.marketNames
    };

    getOrElseLocalStorage(config, defaultValue) {
        let localStorageValue = getLocalStorage(config.ownerPage, config.ownerElement, config.key)
        if (localStorageValue){
            return localStorageValue
        }

        return defaultValue
    }

    getOrElseLocalStorageAsList(config, currentData) {
        let localStorageList = getLocalStorage(config.ownerPage, config.ownerElement, config.key)
       
        if (!localStorageList || !localStorageList.length) {
            return currentData
        } else {
            let existingList = currentData.filter(x => localStorageList.includes(x[config.matchKey]))

            if (existingList.length) {
                return existingList
            } else {
                return currentData
            }
        }
    }

    setPnlLocalStorageAsList(config, data) {
        let dataList = data.map(x => x[config.matchKey])
        setLocalStorage(config.ownerPage, config.ownerElement, config.key, dataList)
    }

    setPnlLocalStorage(config, data) {
        setLocalStorage(config.ownerPage, config.ownerElement, config.key, data)
    }

    componentDidMount() {
        this.onShowButtonClick();
    }

    onShowButtonClick() {
        let filter = {
            start_date: moment(this.state.selectedStartDate).utcOffset(0, true).format(),
            end_date: moment(this.state.selectedEndDate).utcOffset(0, true).format(),
            book_list: this.state.selectedBooks?.map(b => b.id),
            fetch_cb_pnl : this.state.selectedBooks?.length ? this.state.selectedBooks.find(b => b.value === "Crossborder") : true,
            has_vitus_capital : this.state.selectedCompanies?.find(c => c.value === "Vitus Capital"),
            product_list: this.state.selectedProducts?.map(p => p.value),
            trader_list: this.state.selectedTraders?.map(t => t.value),
            market_list: this.state.selectedMarkets?.map(m => m.id),
            position_list: this.state.selectedPositions?.map(p => p.value),
            period_list: this.state.selectedPeriods?.map(p => p.value),
            company_list: this.state.selectedCompanies?.map(c => c.id),
            counter_party_list: this.state.selectedCounterParties?.map(c => c.id),
            trading_venue_list: this.state.selectedTradingVenues?.map(t => t.value),
            delivery_type_list: this.state.selectedDeliveryTypes?.map(d => d.value),
            contract_type_list: this.state.selectedContractTypes?.map(c => c.value),
            hide_past: this.state.hidePast,
            include_adjustment: this.state.includeAdjustment,
            price_source: this.state.selectedPriceSource.value,
        }
        
        this.props.onShowButtonClick(filter)
    }

    onBookChange = books => {
        this.setState({ selectedBooks: books }, () => {
            this.setPnlLocalStorageAsList(localStorageConfig.book, books);
        });
    }

    onMarketChange = selectedMarkets => {
        this.setState({ selectedMarkets: selectedMarkets }, () => {
            this.setPnlLocalStorageAsList(localStorageConfig.market, selectedMarkets);
        });
    }

    onChangePosition = selectedPositions => {
        this.setState({ selectedPositions: selectedPositions }, () => {
            this.setPnlLocalStorageAsList(localStorageConfig.position, selectedPositions);
        });
    }

    onChangePeriod = selectedPeriods => {
        this.setState({ selectedPeriods: selectedPeriods}, () => {
            this.setPnlLocalStorageAsList(localStorageConfig.period, selectedPeriods);
        })
    }

    onCompanyChange = companies => {
        this.setState({ selectedCompanies: companies }, () => {
            this.setPnlLocalStorageAsList(localStorageConfig.company, companies);
        });
    }

    onCompanyCounterParty = counterParties => {
        this.setState({ selectedCounterParties: counterParties }, () => {
            this.setPnlLocalStorageAsList(localStorageConfig.counterParty, counterParties);
        });
    }

    onChangeProduct = products => {
        this.setState({ selectedProducts: products }, () => {
            this.setPnlLocalStorageAsList(localStorageConfig.product, products);
        })
    }

    onChangeTradingVenue = tradingVenues => {
        this.setState({ selectedTradingVenues: tradingVenues }, () => {
            this.setPnlLocalStorageAsList(localStorageConfig.tradingVenue, tradingVenues);
        })
    }

    onChangeTrader = traders => {
        this.setState({ selectedTraders: traders }, () => {
            this.setPnlLocalStorageAsList(localStorageConfig.trader, traders);
        })
    }

    onChangeDeliveryTypes = deliveryTypes => {
        this.setState({ selectedDeliveryTypes: deliveryTypes }, () => {
            this.setPnlLocalStorageAsList(localStorageConfig.deliveryType, deliveryTypes);
        })
    }

    onChangeContractTypes = contractTypes => {
        this.setState({ selectedContractTypes: contractTypes }, () => {
            this.setPnlLocalStorageAsList(localStorageConfig.contractType, contractTypes);
        })
    }


    onChangeStartDate = startDate => {
        this.setState({ selectedStartDate: startDate }, () => {
            this.setPnlLocalStorage(localStorageConfig.startDate, startDate);
        })
    }

    onChangeEndDate = endDate => {
        this.setState({ selectedEndDate: endDate }, () => {
            this.setPnlLocalStorage(localStorageConfig.endDate, endDate);
        })
    }

    onChangeHidePast = (event) => {
        let cheched = event.target.checked
        this.setState({hidePast: cheched}, () => {
            this.setPnlLocalStorage(localStorageConfig.hidePast, cheched);
        });
    }

    onChangeIncludeAdjustments = (event) => {
        let cheched = event.target.checked
        this.setState({includeAdjustment: cheched}, () => {
            this.setPnlLocalStorage(localStorageConfig.adjustment, cheched);
        });
    }

    onChangePriceSource = source => {
        this.setState({ selectedPriceSource: source }, () => {
            this.setPnlLocalStorage(localStorageConfig.priceSource, source);
         })
    }


    render() {
        return (
            <div style={{ "marginTop": "10px" }}>
                <div style={{ "marginTop": "10px", display: "flex", flexDirection: "row" }}>
                    <div style={{ "margin": "5px", "width": "15%" }}>
                        <MultipleSelect
                            title="Books"
                            items={this.props.bookNames}
                            onChange={this.onBookChange}
                            selectedItems={this.state.selectedBooks}
                            disabled={true}
                        >
                        </MultipleSelect>
                        <MultipleSelect
                            title="Products"
                            items={PRODUCT_ARR}
                            onChange={this.onChangeProduct}
                            selectedItems={this.state.selectedProducts}
                        >
                        </MultipleSelect>
                        <MultipleSelect
                            title="Trader"
                            items={TRADER_ARR}
                            onChange={this.onChangeTrader}
                            selectedItems={this.state.selectedTraders}
                        >
                        </MultipleSelect>
                        <MultipleSelect
                            title="Trading Venue"
                            items={TRADING_VENUE_ARR}
                            onChange={this.onChangeTradingVenue}
                            selectedItems={this.state.selectedTradingVenues}
                        >
                        </MultipleSelect>
                        
                    </div>
                    <div style={{ "margin": "5px", "width": "30%" }}>
                        <MultipleSelect
                            title="Delivery Type"
                            items={DELIVERY_TYPE_ARR}
                            onChange={this.onChangeDeliveryTypes}
                            selectedItems={this.state.selectedDeliveryTypes}
                        >
                        </MultipleSelect>
                        <MultipleSelect
                            title="Markets"
                            items={this.props.marketNames}
                            onChange={this.onMarketChange}
                            selectedItems={this.state.selectedMarkets}
                        >
                        </MultipleSelect>
                        <MultipleSelect
                            title="Companies"
                            items={this.props.counterPartyNames.filter(c => c.type === "Vitus")}
                            onChange={this.onCompanyChange}
                            selectedItems={this.state.selectedCompanies}
                        >
                        </MultipleSelect>
                        <MultipleSelect
                            title="Counter Parties"
                            items={this.props.counterPartyNames.filter(c => c.type !== "Vitus")}
                            onChange={this.onCompanyCounterParty}
                            selectedItems={this.state.selectedCounterParties}
                        >
                        </MultipleSelect>
                        
                    </div>
                    <div style={{ "margin": "5px", "width": "15%" }}>
                       <MultipleSelect
                            title="Contract Type"
                            items={CONTRACT_TYPE_ARR}
                            onChange={this.onChangeContractTypes}
                            selectedItems={this.state.selectedContractTypes}
                        >
                        </MultipleSelect>
                        
                        <MultipleSelect
                            title="Positions"
                            items={POSITION_ARR}
                            onChange={this.onChangePosition}
                            selectedItems={this.state.selectedPositions}
                        >
                        </MultipleSelect>
                       { /*
                       <MultipleSelect
                            title="Periods"
                            items={POSITION_PERIOD_ARR}
                            onChange={this.onChangePeriod}
                            selectedItems={this.state.selectedPeriods}
                        >
                        </MultipleSelect>
                        */}

                    </div>
                    <div style={{ "margin": "5px" }}>
                        <TDatePicker
                            type={TDatePickerTypes.month}
                            label={"Start Date"}
                            selectedDate={this.state.selectedStartDate}
                            onSelectedDateChange={this.onChangeStartDate}
                        />

                        <TDatePicker
                            type={TDatePickerTypes.month}
                            label={"End Date"}
                            selectedDate={this.state.selectedEndDate}
                            onSelectedDateChange={this.onChangeEndDate}
                        />
                        <TDropdown
                            label='Price Source'
                            options={PRICE_SOURCE_ARR}
                            width="small"
                            value={this.state.selectedPriceSource}
                            defaultValue={this.state.selectedPriceSource}
                            onSelectedOptionChange={this.onChangePriceSource}
                            disabled={this.state.readOnly}
                        />
                        <div className="t-dropdown-content">
                            <div className="t-dropdown-label">
                                {"Include Adjustments"}
                            </div>
                            <div style={{display: "contents"}}>
                                <Checkbox
                                    color="primary"
                                    checked={this.state.includeAdjustment}
                                    onChange={this.onChangeIncludeAdjustments}
                                    name="include_adjustment"
                                />
                            </div>
                        </div>

                        <div className="t-dropdown-content">
                            <div className="t-dropdown-label">
                                {"Hide Past Days"}
                            </div>
                            <div style={{display: "contents"}}>
                                <Checkbox
                                    color="primary"
                                    checked={this.state.hidePast}
                                    onChange={this.onChangeHidePast}
                                    name="hide_past"
                                />
                            </div>
                        </div>
                       

                    </div>
                   
                </div>

                <div style={{ "margin": "12px", "paddingRight": "250px" }}>
                    <Divider />
                    <AccordionActions>
                        <button
                            size="small"
                            className="btn t-orange-button"
                            onClick={() => this.onShowButtonClick()}
                        >
                            Apply
                        </button>
                    </AccordionActions>
                </div>

            </div>
        );
    }
}

export default PosAndMarkFilter;